import { IconCircleCheckFilled, IconCircleX } from '@tabler/icons-react';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Box, Group, Icon, Stack, Text } from '@zorro/web/design-system';

export type PrerequisiteProps = {
  isValid: boolean;
  label: string;
};

const MatchingPrerequisite = ({ label, isValid }: PrerequisiteProps) => {
  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Icon
        icon={isValid ? IconCircleCheckFilled : IconCircleX}
        color={
          isValid
            ? 'var(--color-icon-fill-success-secondary)'
            : 'var(--color-icon-stroke-error-secondary)'
        }
        height={18}
        width={18}
        style={{ flexShrink: 0, paddingTop: '0.1rem' }}
      />

      <Text size="sm">{label}</Text>
    </Group>
  );
};

type GeneralPrerequisiteProps = {
  title?: string;
  withTooltip: boolean;
  prerequisites: PrerequisiteProps[];
  children: React.ReactNode;
};

export const PrerequisitesTooltip = ({
  title = 'Action',
  withTooltip,
  prerequisites,
  children,
}: GeneralPrerequisiteProps) => {
  return (
    <Tooltip
      position="left"
      maw="19rem"
      offset={15}
      disabled={withTooltip}
      label={
        <Stack gap="0.25rem">
          <Text size="sm" fw={600}>
            {title} requires:
          </Text>
          {prerequisites.map((prerequisite) => (
            <MatchingPrerequisite
              key={prerequisite.label}
              label={prerequisite.label}
              isValid={prerequisite.isValid}
            />
          ))}
        </Stack>
      }
    >
      <Box pos="relative">{children}</Box>
    </Tooltip>
  );
};
